import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
{/* import Interstitial from "../components/interstitial"; */}

export default function Home() {
  return (
    <Layout>
      {/* Hero */}
      <Container
        className="hero"
        maxWidth="false"
        sx={{
          bgcolor: "primary.main",
          py: 8,
        }}
      >
        <Container maxWidth="lg" alignItems="center">
          <Typography
            maxWidth="lg"
            component="h1"
            variant="h1"
            align="center"
            color="primary.contrastText"
            paragraph
            gutterBottom
            sx={{
              my: 0,
              fontSize: { xs: '2rem', sm: '2.4rem', md: '2.8rem', lg: '3.2rem' },
            }}
          >
            Empowering MedTech with Streamlined, Fit-For-Purpose Clinical Research Analytics
          </Typography>
        </Container>
      </Container>

      {/* End Hero */}

      {/* Solutions */}
      <Container
        maxWidth="false"
        className="px-0"
        sx={{
          bgcolor: "bggreen.main",
          pb: 6,
          pt: 8,
        }}
      >
        <Container maxWidth="md" alignItems="center" className="page-subheader">
          <Typography
            component="h2"
            variant="h2"
            align="center"
            color="text.light"
            sx={{
              fontSize: { xs: '1.4rem', sm: '2rem', md: '2.2rem', lg: '2.4rem' },
            }}
          >
            Optimize your total product lifecycle with less cost, time, and risk
          </Typography>
        </Container>
      </Container>
      <div className="section-edge-green"></div>
      <Container
        maxWidth="false"
        className="px-0"
        sx={{
          bgcolor: "primary",
          py: 4,
        }}
      >
          <Container
              maxWidth="false"
              sx={{
                bgcolor: "primary",
                py: 0,
                mb: 4,
              }}
            >
            <Container maxWidth="lg" alignItems="center">
        </Container>
        </Container>
        <Container maxWidth="md"
          sx={{
            pb: 2,
          }}
        >
          <section className="solutions-solution" aria-label="3Aware Capabilities">
          <Typography
              component="h3"
              variant="h3"
              align="center"
              color="text.green2"
              gutterBottom
              sx={{
                fontSize: { xs: '1.3rem', sm: '1.5rem', lg: '2rem' }
              }}
            >
              3Aware Capabilities
            </Typography>
            <Typography
              component="h5"
              variant="h5"
              align="left"
              color="text.primary"
              sx={{
                pb:2,
                fontSize: { xs: '1.1rem', sm: '1.2rem', lg: '1.25rem' },
              }}
            >
              aiSurveillance
            </Typography>
            <Typography
              component="p"
              variant="p"
              align="left"
              color="text.primary"
              paragraph

            >
              3Aware developed aiSurveillance technology for the MedTech sector. A blend of clinical science and data science, it leverages advanced algorithms–applied to electronic health records (EHRs), supply chain management, charge master and other health system inventory & accounting systems–to process and analyze vast amounts of real-world patient data swiftly and accurately. AI- optimized repeatable analytic protocols and decision-making mine and analyze the complete EHR (including information-rich unstructured clinician notes) with ever increasing efficiency. aiSurveillance automates the translation of patient-level, device-specific real-world data into easily digestible patient outcomes… resulting in highest quality, regulatory-grade real-world evidence.
            </Typography>
          </section>
        </Container>
             
        <Container maxWidth="md" alignItems="center"
          sx={{
            pb: 8
          }}
        >
            <section className="solutions-solution last mb-2" aria-label="Label Expansion">
            <Typography
              component="h5"
              variant="h5"
              align="left"
              color="text.primary"
              textTransform="uppercase"
              sx={{
                pb:2,
                fontSize: { xs: '1.1rem', sm: '1.2rem', lg: '1.25rem' },
              }}
            >
                3Aware vs. Traditional Methods
              </Typography>
              <Typography
              component="p"
              variant="p"
              align="left"
              color="text.primary"
              paragraph
              gutterBottom
            >
              Compared to traditional RWE methods, 3Aware reduces time, risk and resources dependency, thus accelerating study timelines… and ongoing access to pre-identified, device-specific cohorts is available for ad hoc studies. Both data bias and operational risk are significantly decreased because the study cohort is immediately known and described via a feasibility assessment, before committing to the full study.
            </Typography>
            </section>
          </Container>
          <div className="section-edge-green-top-flipped"></div>
          <Container
        maxWidth="false"
        sx={{
          bgcolor: "bggreen.main",
          py: 8,
        }}
      >
        <Container maxWidth="md" alignItems="center">
        <Box
            sx={{
              // bgcolor: "primary.light",
              bgcolor: "#f7f3ed",
              // py: 8,
              // px: 8,
              borderRadius: "12px",
              overflow: 'hidden',
            }}
          >
              <StaticImage
                src="../images/data-validity-vs-cost-and-time.png"
                loading="eager"
                width={1650}
                quality={99}
                formats={["auto"]}
                alt=""
                sx={{
                  borderRadius: '10px',
                }}
              />
              </Box>
            </Container>
            </Container>
            <div className="section-edge-green"></div>

            <Container maxWidth="md" alignItems="center" sx={{ mt: 8 }}>
            <section className="solutions-solution" aria-label="">
            <Typography
              component="h3"
              variant="h3"
              align="center"
              color="text.green2"
              gutterBottom
              sx={{
                fontSize: { xs: '1.3rem', sm: '1.5rem', lg: '2rem' }
              }}
            >
                  3Aware Clarity
              </Typography>
              <Typography
              component="h5"
              variant="h5"
              align="left"
              color="text.primary"
              textTransform="uppercase"
              sx={{
                pb:2,
                fontSize: { xs: '1.1rem', sm: '1.2rem', lg: '1.25rem' },
              }}
            >
              Device & Patient Insights
            </Typography>
            <Typography
              component="p"
              variant="p"
              align="left"
              color="text.primary"
              paragraph
              gutterBottom
            >
              3Aware pinpoints specific devices and device categories to specific patient events via UDI numbers, integrated from a variety of health system data sources. Comprehensive longitudinal data, including Patient Reported Outcome Measures (PROMs), EHR imaging and procedure-specific clinical evidence, is available for a multitude of compliance and portfolio optimization uses… for example, tracking Class III implants.
              </Typography>
              <Typography
                component="h5"
                variant="h5"
                align="left"
                color="text.primary"
                textTransform="uppercase"
                sx={{
                  pb:2,
                  fontSize: { xs: '1.1rem', sm: '1.2rem', lg: '1.25rem' },
                }}
              >
              Scientific Workbench
            </Typography>
            <Typography
              component="p"
              variant="p"
              align="left"
              color="text.primary"
              paragraph
              gutterBottom
            >
              The AI-powered scientific work bench employs Reinforced Learning from Human Feedback, Natural Language Processing & Understanding (NLP/U) and soon: End-Point Specific LLMs, to streamline the analysis of complex data, maximizing real-time clinical insights and regulatory readiness. Patient level findings are provided, as well as clear summaries, to facilitate report generation.
              </Typography>
              <Typography
                component="h5"
                variant="h5"
                align="left"
                color="text.primary"
                textTransform="uppercase"
                sx={{
                  pb:2,
                  fontSize: { xs: '1.1rem', sm: '1.2rem', lg: '1.25rem' },
                }}
              >
                Governance
              </Typography>
              <Typography
              component="p"
              variant="p"
              align="left"
              color="text.primary"
              paragraph
              gutterBottom
              sx={{
                pb:2
              }}
            >
              3Aware ensures rigorous standards to protect data integrity and patient health information. Our platform is built on a HITRUST® Risk-based, 2-year certified platform that employs robust cybersecurity measures, including continuous vulnerability scanning and annual third-party audits, which have consistently shown no vulnerabilities. All data is de-identified according to stringent expert determination standards and encrypted in transmission and at rest, ensuring data privacy. Additionally, access to client information is strictly controlled, with a least privilege and need-to-know policy enforced alongside a thorough quality assurance process to maintain data integrity and reliability.
              </Typography>
            </section>

          </Container>
      </Container>
      <div className="section-edge-darkblue-top"></div>
        <Container 
          maxWidth="false" 
          alignItems="center"
          sx={{
            bgcolor: "primary.main",
            py: 8,
          }}
        >
          <Container maxWidth="lg">
          <section className="quote-component" aria-label="Quote">
                <div className="quote-left">
                    <div className="quote-author-photo">
                <StaticImage
                    src="../images/scott-snyder.png"
                    loading="eager"
                    width={400}
                    quality={99}
                    formats={["auto"]}
                    alt=""
                    borderRadius="0px"
                    />
                </div>
            
                
            </div>
            <div className="quote-right">
                <blockquote cite="https://example.com">
                    <p>"Of the data options available, 3Aware is the first and only platform I know of that connects specific devices to patient medical records and offers users direct access to de-identified patient-level data, including unstructured clinical notes."</p>
                </blockquote>
                <p className="quote-author">Scott Snyder, PhD</p>
                <p className="quote-author-title">Sr. Director of Statistics &amp; Data Science<br/>Cook Research Incorporated</p>
                
            </div>
        </section>
        </Container>
        
        </Container>
        <div className="section-edge-darkblue-bottom"></div>
        
        <Container maxWidth="md" alignItems="center" sx={{ mt: 8, mb: 8 }}>
            <section className="solutions-solution" aria-label="">
            <Typography
              component="h3"
              variant="h3"
              align="center"
              color="text.green2"
              gutterBottom
              sx={{
                fontSize: { xs: '1.3rem', sm: '1.5rem', lg: '2rem' },
              }}
            >
              3Aware Coverage
              </Typography>
              <Typography
              component="p"
              variant="p"
              align="left"
              color="text.primary"
              paragraph
              gutterBottom
              sx={{
                pb:2
              }}
            >
              3Aware has coverage of over 60K devices, sourced from a patient population of over 20M, and growing. Data is integrated from electronic health records and a myriad of administrative, operational, accounting/billing, supply chain management and operating room scheduling systems. A specific device is connected to a specific patient by connecting data points via their various unique identifiers.
              </Typography>
            </section>
        </Container>
      

      <div className="section-edge-darkblue2-top-flipped"></div>
      <Container
        maxWidth="false"
        sx={{
          bgcolor: "rgba(11, 29, 45, 1)",
          py: 8,
        }}
      >
        <Container maxWidth="md" alignItems="center">
          <Typography
            component="h3"
            variant="h3"
            align="center"
            color="bggreenog.main"
            paragraph
            gutterBottom
            sx={{
              fontSize: { xs: '1.3rem', sm: '1.5rem', lg: '2rem' },
            }}
          >
            3Aware Engagement Model
          </Typography>
          
          {/* Custom vertical timeline */}
<Box
  sx={{
    position: 'relative',
    '&:before': {
      content: '""',
      position: 'absolute',
      left: { xs: '20px', md: '50%' },
      top: 0,
      bottom: 0,
      width: '2px',
      bgcolor: 'grey.300',
    },
    marginTop: '4em',
  }}
>
  {[
    { time: 'Identify Devices', title: 'By UDI, Version/Model Number or<br/>Catalog Number' },
    { time: 'First Cut', title: 'Pinpoint Population(s) of Interest<br/>Minimize Selection' },
    { time: 'Intake Process', title: 'Collaborative Interview to Identify Outcomes, <br/>Data Elements & Required Follow-Up' },
    { time: 'Feasibility Assesment', title: 'Access Sample:  ≥10% of Full Cohort <br/>De-Risk Full Project' },
    { time: 'Full Project', title: 'Sandbox Environment<br/>Scientific Support' },
    { time: 'Ongoing Clinical Partnership', title: 'Subscription Ensures Ongoing Access<br/>Repeatable Projects<br/>Continuing Surveillance' },
  ].map((step, idx) => {
    const isEven = idx % 2 === 0;
    return (
      <Box
        key={idx}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'row', md: 'row' },
          alignItems: 'center',
          mb: 4,
          alignContent: 'start',
        }}
      >
        {isEven ? (
          <>
            {/* Left: time */}
            <Box
              sx={{
                width: { xs: '100%', md: '50%' },
                textAlign: { xs: 'left', md: 'right' },
                pr: 2,
                mb: { xs: 1, md: 0 },
                pl: { xs: 8, sm: 8, md: 2 },
              }}
            >
              <Typography
                variant="body2"
                color="primary.contrastText"
                component="div"

                dangerouslySetInnerHTML={{ __html: step.time }}
                sx={{
                  textAlign: { xs: 'left', md: 'right' },
                  pr: '2em',
                  fontWeight: '600',
                  textTransform: 'uppercase',
              }}
              />

              <Typography
                variant="body1"
                component="div"
                dangerouslySetInnerHTML={{ __html: step.title }}
                sx={{

                  color: 'text.green1',
                  pr: '2em',
                }}
              />
            </Box>
            {/* Dot */}
            <Box
              sx={{
                width: '34px',
                height: '34px',
                borderRadius: '50%',
                bgcolor: 'rgba(11, 29, 45, 1)',
                mx: 2,
                flexShrink: 0,
                textAlign: 'center',
                ml: '-16px',
                lineHeight: '30px',
                zIndex: '1',
                border: '2px solid #fefefe',
                alignSelf: 'start',
                position: { xs: 'absolute', sm: 'absolute', md: 'inherit' },
                left: { xs: '20px', md: 'auto'}
              }}
            >
              <Typography variant="caption" color="primary.contrastText">
                {idx + 1}
              </Typography>
          </Box>

          </>
        ) : (
          <>
            {/* Left: title */}
            <Box
              sx={{
                flex: 1,
                textAlign: 'right',
                pr: 2,
                mb: { xs: 1, md: 0 },
              }}s
            >
              
            </Box>
            {/* Dot */}
            <Box
              sx={{
                width: '34px',
                height: '34px',
                borderRadius: '50%',
                bgcolor: 'rgba(11, 29, 45, 1)',
                mx: 2,
                flexShrink: 0,
                textAlign: 'center',
                mr: '-16px',
                lineHeight: '30px',
                zIndex: '1',
                border: '2px solid #fefefe',
                alignSelf: 'start',
                position: { xs: 'absolute', sm: 'absolute', md: 'inherit' },
                left: { xs: '-12px', md: 'auto'}
              }}
            >
              <Typography variant="caption" color="primary.contrastText">
                {idx + 1}
              </Typography>
              
            </Box>
            {/* Right: time */}
            <Box
              sx={{
                width: { xs: '100%', md: '50%' },
                textAlign: { xs: 'left', md: 'left' },
                pl: { xs: 6, md: 6 },
              }}
            >
              <Typography
                variant="body2"
                color="primary.contrastText"
                component="div"

                dangerouslySetInnerHTML={{ __html: step.time }}
                sx={{
                  textAlign: { xs: 'left', md: 'left' },
                  pr: '2em',
                  fontWeight: '600',
                  textTransform: 'uppercase',
              }}
              />
              <Typography
                variant="body1"
                component="div"
                dangerouslySetInnerHTML={{ __html: step.title }}
                sx={{

                  color: 'text.green1',

                }}
              />
            </Box>
          </>
        )}
      </Box>
    );
  })}
</Box>
          
        </Container>
        
      </Container>
      <div className="divider-gradient"></div>
      {/* End Solutions */}
      {/* <Interstitial/> */}
    </Layout>
  );
}

export const Head = () => <Seo title="Product" description="Discover how clinical research analytics can enhance patient safety and optimize trial design for better outcomes. Learn more about this powerful tool." />
